var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "tooltips-enabled",
          rawName: "v-tooltips-enabled",
          value: {
            active: _vm.tooltip,
            title: _vm.title
          },
          expression:
            "{\n                    active:tooltip,\n                    title:title\n                }"
        }
      ],
      staticClass: "md-form"
    },
    [
      _c("i", { staticClass: "prefix material-icons" }, [_vm._v("date_range")]),
      _vm._v(" "),
      _c("date-picker-component", {
        attrs: {
          tabindex: _vm.tabindex,
          id: _vm.id,
          name: _vm.field,
          set_active: _vm.set_active,
          set_date: _vm.set_date,
          set_now: _vm.set_now
        },
        on: { dateSet: _vm.dateSet }
      }),
      _vm._v(" "),
      _c("label", { attrs: { for: _vm.id } }, [_vm._v(_vm._s(_vm.label))])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b56b0d4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b56b0d4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./app/Shared/Resources/Assets/js/components/base/BaseDatePicker.vue
// module id = 781
// module chunks = 0